var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("second-nav-bar"),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-container scroll" },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "medium",
                          disabled: _vm.isCity || _vm.$regional.disableCRUD
                        },
                        on: { click: _vm.handleAdd }
                      },
                      [_vm._v("添加机构")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticClass: "table" },
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-table",
                      { attrs: { data: _vm.departmentData, size: "medium" } },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "name", label: "机构名称" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "creditCode", label: "信用代码" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "行政级别" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.level === 1
                                          ? "市级"
                                          : "区（县）级"
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "region.name", label: "所属地区" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "adminAccount", label: "管理账号" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { fixed: "right", label: "操作" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        disabled:
                                          _vm.isCity ||
                                          _vm.$regional.disableCRUD
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleEdit(
                                            scope.$index,
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        disabled:
                                          _vm.isCity ||
                                          _vm.$regional.disableCRUD
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleDelete(
                                            scope.$index,
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("department-edit-box", {
        attrs: { visible: _vm.editorVisible, identify: _vm.departmentInfo },
        on: {
          "update:visible": function($event) {
            _vm.editorVisible = $event
          },
          "edit-result": _vm.initDepartment
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v("运营 / 机构管理")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-3a88c472", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3a88c472","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/operate/DepartmentManage.vue
// module id = null
// module chunks = 